// extracted by css-extract-rspack-plugin
export default {"card":"Bd84fAU1UQ49v6lF","copy":"k7FGUNXR6Lk64vT0"};